import React from 'react';


function CompCheckout({ setCart, cart, navigation }) {
  const { previous,next } = navigation;
  return (
    <div>
      <div>Finalizar</div>
      <div>
        <button onClick={previous}>Anterior</button>
        <button onClick={next}>Finalizar</button>
      </div>
    </div>
  );
}

export default CompCheckout;